import useCustomerInfo from "@repo/shopify/hooks/useCustomerInfo";
import useCustomerInfoCaa from "@repo/shopify/hooks/useCustomerInfoCaa";
import { extractId } from "@repo/shopify/utils/common";

import useLanguage from "@hooks/useLanguage";

import useCustomer from "@queries/useCustomer";
import useCustomerCaa from "@queries/useCustomerCaa";

import { useCustomerStore } from "@store/customer";

export default function useAddresses() {
  const { lang } = useLanguage();

  const { customer, token, caaCustomer, updateCaa } = useCustomerStore();

  const { fetchCustomer } = useCustomer();
  const { fetchCaaCustomer } = useCustomerCaa();

  const { addresses } = useCustomerInfo(customer, "thisisneverthat");
  const { addresses: caaAddresses } = useCustomerInfoCaa(caaCustomer, "thisisneverthat");

  const isJp = lang === "jp";

  const onCompletedMutation = async () => {
    if (isJp) {
      const data = await fetchCaaCustomer();
      if (data?.customer) updateCaa(data.customer);
      return;
    }

    await fetchCustomer({ customerAccessToken: token.accessToken });
  };

  const defaultAddress = isJp ? caaCustomer?.defaultAddress : customer.defaultAddress;

  const otherAddresses = (isJp ? caaAddresses : addresses).filter((node) => extractId(node.id) !== extractId(String(defaultAddress?.id)));

  return {
    onCompletedMutation,
    defaultAddress,
    otherAddresses,
  };
}
